module.exports = __webpack_public_path__ + "CreativeDirection1.png?9dad0dbcc82cf0fcedc384a0cb36bdd9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection1.png
// module id = 20
// module chunks = 0